<div [class]="theme">
  <input
    #addressInput
    pInputText
    [disabled]="disabled"
    [placeholder]="placeholder | translate"
    (input)="addressChanged($event)"
    (blur)="onTouched(); onBlur($event)"
    (focus)="onFocus($event)"
    [(ngModel)]="addressValue"
    [readonly]="readonly"
    class="full-width-input"
    [class.invalid-input]="isInvalidControl" />
  @if (showClear && !!addressValue && !(disabled || readonly)) {
    <button class="clear" (click)="clearAddress()" type="button">
      <img src="assets/images/icons/close.svg" alt="clear-address" />
    </button>
  }
  @if (isInvalidControl) {
    <sxw-error-message [message]="control ? control.errors : null" />
  }
</div>
